import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Link } from 'react-router-dom';
import mapValues from 'lodash/mapValues';

import { Theme } from '@app/theme';
import { useNavbarColor } from './NavbarColorContext';

const useStyles = createUseStyles((theme: Theme) =>
  mapValues(theme.colorDefinitions, (colorDef, color) => ({
    ...theme.flexCenter,

    width: theme.height.small,
    height: theme.height.small,

    borderRadius: '50%',

    backgroundColor: color === 'green' ? theme.colors.white : colorDef.std,
    color: color === 'green' ? colorDef.std : theme.colors.white,

    marginBottom: theme.marginBase * 3,

    [theme.media.mobile]: {
      display: 'none',
    },
    '& > i': {
      fontSize: theme.iconSize.large,
    },
  })),
);

export const NavbarTandemzLogo = () => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const color = useNavbarColor();

  return (
    <Link to="/" className={classes[color]}>
      <i className="custom-icon-font-tandemz" title="Logo" />
    </Link>
  );
};
